import {
  FormTranslationType,
  normalizeLanguageForDisplay,
} from '@seaters/constants';
import {
  baseColor100,
  baseColor900,
  colorTextBaseLight,
  getColorContrast,
} from '@seaters/ui';

export const getLocale = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const lang = searchParams.get('lang') || 'en';
  const locale = lang === 'nl_NL' ? 'nl-nl' : lang;

  return locale;
};

export const decodeAmpHtmlEntity = (html: string) =>
  html.replace(/&amp;/g, '&');

/**
 * Fan-group brand colour split into AA-safe uses (WCAG 1.4.3). `getColorContrast`
 * picks white only below the luminance where white reaches 4.5:1, so it doubles as
 * the pass/fail check for the brand colour as text on white.
 */
export const getBrandColors = (
  color: string | null | undefined,
  fallback: string
) => {
  const hex = /^#?[0-9a-f]{6}$/i.test(color ?? '')
    ? `#${color?.replace('#', '')}`
    : fallback;
  const rgb = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  const passesOnWhite = getColorContrast(rgb).colorContrast === 'white';

  return {
    brand: hex,
    text: passesOnWhite ? hex : baseColor900,
    onBrand: passesOnWhite ? baseColor100 : colorTextBaseLight,
  };
};

/**
 * Picks the invitation language from a translation map and falls back to English.
 * `lang` is set only for that fallback, so the passage can carry its own `lang`
 * (WCAG 3.1.2).
 */
export const getTranslationWithLang = (
  map: FormTranslationType | null | undefined,
  language: string
): { text: string; lang?: string } => {
  const text = map?.[language] || map?.[normalizeLanguageForDisplay(language)];
  if (text) return { text };
  return map?.en ? { text: map.en, lang: 'en' } : { text: '' };
};
